import { render, staticRenderFns } from "./Learn-detailcopy.vue?vue&type=template&id=18790ab8&"
import script from "./Learn-detailcopy.vue?vue&type=script&lang=js&"
export * from "./Learn-detailcopy.vue?vue&type=script&lang=js&"
import style0 from "./Learn-detailcopy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports